import {IconLink} from '@molecules/ContentLinkCard/IconLink';
import * as React from 'react';

import {IContentBlock} from 'features/blocks/types';

import 'components/blocks/PageLinks/StandardPageBlock/style.scss';
import {SiteIcons} from "features/template/types";

export interface StandardPageBlockType {
    title: string;
    linkUrl: string;
    icon: SiteIcons;
}
type Props = IContentBlock<StandardPageBlockType>;

export const StandardPageBlock: React.FunctionComponent<Props> = ({data, id}) => {
    return (
        <div className="standard-page-block" id={id}>
            <IconLink
                headline={data.title}
                href={data.linkUrl}
                icon={data.icon}
            />
        </div>
    )
};
